import * as React from 'react';

/**
 * The one row a report's actions live in (IMM-640.1) — directly under the format
 * toggle and above the frame, right-aligned.
 *
 * It exists as its own export rather than only as a slot on
 * {@link import('./sandboxed-html-viewer').SandboxedHtmlViewer} because the PDF
 * path renders no viewer at all: the actions ARE the body there. A slot alone
 * would leave these classes copied into every app that shows a PDF report, which
 * is precisely the drift IMM-640 exists to end — the row's position is decided
 * here, once, and both mount points inherit it.
 *
 * Deliberately takes `children` only. A `className` escape hatch would let one
 * caller nudge the row and re-open the divergence.
 */
export function ReportActionRow({ children }: { readonly children: React.ReactNode }) {
  // `flex-wrap items-center` is carried over from the rows this replaces, not
  // dropped with the rest of the lift: the row now holds several `whitespace-nowrap`
  // buttons, and the customer app renders it inside a card column narrow enough that
  // an unwrapping row would push a control off the start edge (BL-043) — which no
  // jsdom test can observe (BL-018).
  return <div className="mb-2 flex flex-wrap items-center justify-end gap-2">{children}</div>;
}
